import { createFileRoute } from '@tanstack/react-router'

import { ReturnVehicle } from '@/features/drives/return-vehicle'
import { handoverGate } from '@/features/handover/gate'

/** The return desk, and the completed drive it becomes, at `/bookings/{id}/return`. One URL for both. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/return')({
  ...handoverGate(),
  component: ReturnVehicle,
})
